import React, { useState } from 'react';
import { FaExchangeAlt, FaArrowRight, FaArrowLeft, FaExternalLinkAlt } from 'react-icons/fa';
import './TransactionList.css';

function TransactionList({ transactions, isLoading, error, account }) {
  const [hoveredTx, setHoveredTx] = useState(null);

  const formatValue = (value) => {
    const num = parseFloat(value);
    if (num >= 1e9) return (num / 1e9).toFixed(2) + 'B';
    if (num >= 1e6) return (num / 1e6).toFixed(2) + 'M';
    if (num >= 1e3) return (num / 1e3).toFixed(2) + 'K';
    return num.toFixed(2);
  };

  const formatAddress = (address) => {
    return address ? `${address.slice(0, 6)}...${address.slice(-4)}` : 'Unknown';
  };

  const weiToHuman = (wei) => {
    return parseFloat(wei) / 1e18;
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp * 1000);
    return date.toLocaleString();
  };

  return (
    <section className="widget transactions">
      <h2><FaExchangeAlt /> Recent Transactions</h2>
      <div className="transaction-list">
        {error ? (
          <p className="error-message">{error}</p>
        ) : isLoading ? (
          <p>Loading transactions...</p>
        ) : transactions.length > 0 ? (
          transactions.slice(0, 20).map((tx, index) => (
            <div 
              key={index} 
              className="transaction-item"
              onMouseEnter={() => setHoveredTx(tx.hash)}
              onMouseLeave={() => setHoveredTx(null)}
            >
              <div className="tx-icon">
                {tx.from.toLowerCase() === account.toLowerCase() ? <FaArrowRight /> : <FaArrowLeft />}
              </div>
              <div className="tx-details">
                <span className="tx-type">
                  {tx.from.toLowerCase() === account.toLowerCase() ? 'Sent' : 'Received'}
                </span>
                <span className="tx-value">{formatValue(weiToHuman(tx.value))} HUMAN</span>
                <span className="tx-address">
                  {tx.from.toLowerCase() === account.toLowerCase() 
                    ? `To: ${formatAddress(tx.to)}`
                    : `From: ${formatAddress(tx.from)}`
                  }
                </span>
                <span className="tx-time">{formatDate(tx.timestamp)}</span>
              </div>
              {hoveredTx === tx.hash && (
                <a 
                  className="tx-details-link"
                  href={`https://scan.earth.ooo/tx/${tx.hash}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="View Details"
                >
                  <FaExternalLinkAlt />
                </a>
              )}
            </div>
          ))
        ) : (
          <p>No recent transactions found for this account.</p>
        )}
      </div>
    </section>
  );
}

export default TransactionList;